/* Display and input checks for money. Never used to add amounts up — the
   server computes every total and sends exact two-decimal strings. */

const RUPEES = new Intl.NumberFormat("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function formatRupees(value) {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  return Number.isFinite(n) ? `₹${RUPEES.format(n)}` : "—";
}

/* "19.05", "20", "0" are fine; "-1", "1.555", "abc", "" are not. */
export function isMoney(value, { max = 99999999 } = {}) {
  const text = String(value ?? "").trim();
  if (!/^\d+(\.\d{1,2})?$/.test(text)) return false;
  return Number(text) <= max;
}
